/* ============================================================================
   JuiceBox Adventskalender — bonus line reconciler
   Keeps the €0,00 "Digitaler Adventskalender" line in step with the calendar:
     N calendars in the cart (Light + Original quantities) ⇒ ONE bonus line at quantity N
     no calendar in the cart                                ⇒ no bonus line
   Runs on every page (loaded from layout/theme.liquid) because the drawer is
   everywhere. Reads its ids from the script tag's data attributes.

   Why an external asset: the cart drawer re-renders via innerHTML, which never
   re-executes an inline <script> (rule in layout/theme.liquid).

   Timing: Impact's CartDrawer swaps its inner HTML 1250 ms after a non-add
   `cart:change`, using the (by then stale) sections HTML from that event. A
   reconcile that lands before that swap gets painted over, so anything but a
   `variant:add` is debounced past the swap. Convergence: every write ends in
   `cart:refresh`, which re-enters here, finds nothing to do, and stops.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__jbAdvBonusBound) return;
  window.__jbAdvBonusBound = true;

  var script = document.currentScript;
  if (!script) return;
  var productId = parseInt(script.getAttribute('data-adv-product-id'), 10);
  var bonusId = parseInt(script.getAttribute('data-adv-bonus-id'), 10);
  if (!productId || !bonusId) return;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var DRAWER_SWAP_DELAY = 1400; // > the drawer's 1250 ms delayed swap

  var inFlight = false;
  var rerun = false;
  var pendingTimer = null;

  function fetchCart() {
    return fetch(routeRoot + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function plan(cart) {
    var items = (cart && cart.items) || [];
    var calendarQty = items
      .filter(function (i) { return i.product_id === productId; })
      .reduce(function (sum, i) { return sum + i.quantity; }, 0);
    var bonusLines = items.filter(function (i) { return i.variant_id === bonusId; });
    var bonusQty = bonusLines.reduce(function (sum, l) { return sum + l.quantity; }, 0);

    if (calendarQty > 0 && bonusLines.length === 0) {
      return { add: calendarQty };
    }
    if (calendarQty === 0 && bonusLines.length) {
      var updates = {};
      bonusLines.forEach(function (l) { updates[l.key] = 0; });
      return { updates: updates };
    }
    if (calendarQty > 0 && (bonusLines.length > 1 || bonusQty !== calendarQty)) {
      // one bonus line, quantity = number of calendars; any duplicate lines go
      var fix = {};
      bonusLines.forEach(function (l, idx) { fix[l.key] = idx === 0 ? calendarQty : 0; });
      return { updates: fix };
    }
    return null;
  }

  function write(action) {
    if (action.add) {
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: HEADERS,
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: bonusId, quantity: action.add, properties: { _adv_bonus: '1' } }] })
      });
    }
    return fetch(routeRoot + 'cart/update.js', {
      method: 'POST',
      headers: HEADERS,
      credentials: 'same-origin',
      body: JSON.stringify({ updates: action.updates })
    });
  }

  async function reconcile(cart) {
    if (inFlight) {
      rerun = true;
      return;
    }
    inFlight = true;
    try {
      if (!cart) cart = await fetchCart();
      var action = plan(cart);
      if (action) {
        var res = await write(action);
        if (!res.ok) {
          var body = await res.json().catch(function () { return {}; });
          console.warn('[jb-adv-bonus-sync] write refused', body.description || res.status);
        }
        // Full drawer re-render from the server; also re-enters this reconciler (no-op once consistent).
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('[jb-adv-bonus-sync]', err);
    } finally {
      inFlight = false;
      if (rerun) {
        rerun = false;
        reconcile();
      }
    }
  }

  function schedule(cart, delay) {
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      pendingTimer = null;
      reconcile(cart);
    }, delay);
  }

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    var cart = detail.cart && detail.cart.items ? detail.cart : null;
    if (detail.baseEvent === 'variant:add') {
      schedule(cart, 0);
    } else {
      // Quantity change / removal in the drawer: wait out the drawer's delayed swap, then re-read the cart.
      schedule(null, DRAWER_SWAP_DELAY);
    }
  });

  document.addEventListener('cart:refresh', function () {
    schedule(null, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reconcile(); });
  } else {
    reconcile();
  }
})();
